/**
 * LionO360 Activity API
 * LionO360 ActivityAPI Specification
 *
 * OpenAPI spec version: 1.0.2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { TaskCategory } from '../model/taskCategory';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {environment} from "src/environments/environment";
import { AccountUserService } from 'src/app/service/account.service';
import { HttpService } from 'src/app/modules/shared/services/http.service';


@Injectable()
export class TaskCategoryService {

    protected basePath = environment.activity;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    user: any;
    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, protected accountUserService: AccountUserService,
    private httpService: HttpService) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        this.accountUserService.user.subscribe(x => this.user = x);
    }


    

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get all TaskCategory
     * Returns a list of TaskCategory
     * @param organizationId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // public lionO36020APITaskCategoryGet(organizationId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TaskCategory>>;
    // public lionO36020APITaskCategoryGet(organizationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TaskCategory>>>;
    // public lionO36020APITaskCategoryGet(organizationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TaskCategory>>>;
    // public lionO36020APITaskCategoryGet(organizationId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    //     if (organizationId === null || organizationId === undefined) {
    //         throw new Error('Required parameter organizationId was null or undefined when calling lionO36020APITaskCategoryGet.');
    //     }

    //     let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    //     if (organizationId !== undefined && organizationId !== null) {
    //         queryParameters = queryParameters.set('organizationId', <any>organizationId);
    //     }

    //     let headers = this.defaultHeaders;

    //     // to determine the Accept header
    //     let httpHeaderAccepts: string[] = [
    //         'text/plain',
    //         'application/json',
    //         'text/json'
    //     ];
    //     const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    //     if (httpHeaderAcceptSelected != undefined) {
    //         headers = headers.set('Accept', httpHeaderAcceptSelected);
    //     }

    //     // to determine the Content-Type header
    //     const consumes: string[] = [
    //     ];

    //     return this.httpClient.request<Array<TaskCategory>>('get',`${this.basePath}/LionO360/2.0/API/TaskCategory`,
    //         {
    //             params: queryParameters,
    //             withCredentials: this.configuration.withCredentials,
    //             headers: headers,
    //             observe: observe,
    //             reportProgress: reportProgress
    //         }
    //     );
    // }

    lionO36020APITaskCategoryGet(organizationId){
        return this.httpClient.get(`${this.basePath}/LionO360/2.0/API/TaskCategory?organizationId=${organizationId}`);
    }

    //#region newTaskCategory API
    newTaskCategoryGet(){
        return this.httpClient.get(`${this.basePath}/LionO360/2.0/API/TaskCategory/Category`);
    }

    getTaskActiveCategoryGet(){
        return this.httpClient.get(`${this.basePath}/LionO360/2.0/API/TaskCategory/ActiveCategory`);
    }

    addNewTaskCategoryGet(data:any){
        return this.httpClient.post(`${this.basePath}/LionO360/2.0/API/TaskCategory/Category`, data);
    }

    // ****Setting TaskCategory start****
    lionO36020APITaskCategoryGetList(){
        return this.httpClient.get(`${this.basePath}/LionO360/2.0/API/TaskCategory/Category`);
    }

    lionO36020APITaskCategoryDelete(categoryId){
        return this.httpClient.delete(`${this.basePath}/LionO360/2.0/API/TaskCategory/${categoryId}`);
    }

    addOrUpdateTaskCategory(data: any) {
        if (data.id === 0 || data.id === undefined) {
          return this.httpClient.post(`${this.basePath}/LionO360/2.0/API/TaskCategory/Category`, data);
        } else {
          return this.httpClient.put(`${this.basePath}/LionO360/2.0/API/TaskCategory/Category`, data);
        }
      }

    getColumnSetting(categoryModuleId,categorychannelId) {
        return this.httpClient.get<any>(`${environment.configUrl}V2/ColumnSetting/Module/${categoryModuleId}/Channel/${categorychannelId}`)
    }

    resetColumnSetting(categoryModuleId,categorychannelId) {
        return this.httpService.update(`${environment.configUrl}V2/ColumnSetting/Reset/Module/${categoryModuleId}/Channel/${categorychannelId}`);
    }

    updateColumnSetting(data) {
        return this.httpClient.put<any>(`${environment.configUrl}V2/ColumnSetting`, data)
    }

    saveFieldsList(data){
        return this.httpClient.post(`${environment.activity}/LionO360/2.0/API/Task/UpdateTemplate`, data);
    }

    getFieldsList(){
        return this.httpClient.get<any>(`${environment.activity}/LionO360/2.0/API/Task/GetTemplatePermission`);
    }

    getTaskList(userFilter,data){
        return this.httpClient.post<any>(`${environment.activity}/LionO360/2.0/API/TaskList?userFilter=${userFilter}`, data);
    }
    // ****Setting TaskCategory end****
    
    /**
     * Deletes a TaskCategory
     * 
     * @param id id to delete
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lionO36020APITaskCategoryIdDelete(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public lionO36020APITaskCategoryIdDelete(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public lionO36020APITaskCategoryIdDelete(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public lionO36020APITaskCategoryIdDelete(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling lionO36020APITaskCategoryIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/LionO360/2.0/API/TaskCategory/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find TaskCategory by ID
     * Returns a single TaskCategory
     * @param id ID of TaskCategory to return
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lionO36020APITaskCategoryIdGet(id: number, observe?: 'body', reportProgress?: boolean): Observable<TaskCategory>;
    public lionO36020APITaskCategoryIdGet(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskCategory>>;
    public lionO36020APITaskCategoryIdGet(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskCategory>>;
    public lionO36020APITaskCategoryIdGet(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling lionO36020APITaskCategoryIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TaskCategory>('get',`${this.basePath}/LionO360/2.0/API/TaskCategory/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add a new TaskCategory
     * 
     * @param body TaskCategory object that needs to be added
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lionO36020APITaskCategoryPost(body: TaskCategory, observe?: 'body', reportProgress?: boolean): Observable<TaskCategory>;
    public lionO36020APITaskCategoryPost(body: TaskCategory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskCategory>>;
    public lionO36020APITaskCategoryPost(body: TaskCategory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskCategory>>;
    public lionO36020APITaskCategoryPost(body: TaskCategory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling lionO36020APITaskCategoryPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaskCategory>('post',`${this.basePath}/LionO360/2.0/API/TaskCategory`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an existing TaskCategory
     * 
     * @param body TaskCategory object that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lionO36020APITaskCategoryPut(body: TaskCategory, observe?: 'body', reportProgress?: boolean): Observable<TaskCategory>;
    public lionO36020APITaskCategoryPut(body: TaskCategory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskCategory>>;
    public lionO36020APITaskCategoryPut(body: TaskCategory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskCategory>>;
    public lionO36020APITaskCategoryPut(body: TaskCategory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling lionO36020APITaskCategoryPut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaskCategory>('put',`${this.basePath}/LionO360/2.0/API/TaskCategory`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
